import * as stateManagement from '@/stateManagement';

export const {
  isDraggingSel,
  isResizingSel,
  isRotatingSel,
  isDuringMouseActionSel,
} = stateManagement.stateMapperArgsSelectors.mouseSels;
